import { useEffect } from "react";

import { Cuer } from "cuer";
import { useLocalSearchParams } from "expo-router";

declare global {
  interface Window {
    downloadQR: () => void;
    ReactNativeWebView: {
      postMessage: (message: string) => void;
    };
  }
}

export default function QRPage() {
  const { url }: { url: string } = useLocalSearchParams();

  // Expose a function to serialize the SVG and send it to native
  // useDownloadQR();

  if (!url) return null;

  return (
    <Cuer.Root
      value={url}
      color="rgb(25, 28, 28)"
      id="qr-code"
      style={{ backgroundColor: "rgb(250, 253, 251)" }}
    >
      <Cuer.Cells />
      <Cuer.Finder />
      <Cuer.Arena>
        <CuantoSvg />
      </Cuer.Arena>
    </Cuer.Root>
  );
}

function CuantoSvg() {
  return (
    <svg
      width="4px"
      height="4px"
      viewBox="0 0 256 256"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.2551 199.966C27.2949 201.417 28.3468 202.884 29.3988 204.374C29.79 204.244 30.0277 204.113 30.1922 204.023C30.447 203.884 30.5262 203.84 30.7282 204.042C39.5324 195.902 48.2536 187.762 56.9748 179.622C65.7002 171.479 74.4256 163.335 83.234 155.191C84.2309 154.195 85.5601 152.866 85.8925 151.537C86.2249 150.539 85.8925 148.545 85.2279 147.881C84.5633 147.215 82.9017 147.215 81.9047 147.549C80.7406 147.881 79.6597 148.38 78.5788 148.879C77.4997 149.377 76.4205 149.875 75.2584 150.207C69.9413 151.868 64.6243 152.532 59.6396 150.207C50.667 145.886 44.353 138.908 41.3622 129.271C38.7037 120.298 39.7007 111.326 41.6945 102.353C47.0116 78.4266 61.3012 61.4784 81.5724 48.8504C95.862 40.2103 111.813 36.8871 128.429 36.5547C136.737 36.5547 143.383 31.9024 146.041 23.9267C146.146 23.5581 146.26 23.1811 146.376 22.7985C146.989 20.7663 147.651 18.5734 147.37 16.6158C145.709 6.64631 137.734 0 127.764 0C116.466 0 104.835 1.32927 93.868 4.32011C74.2615 9.63716 57.3133 20.2713 42.0269 33.5638C-3.1681 73.4417 -13.1376 136.914 18.1001 188.091C20.5466 192.005 23.3534 195.92 26.2551 199.966Z"
        fill="#49B5B0"
      />
      <path
        d="M46.4107 221.916C46.3894 221.939 46.3681 221.962 46.3468 221.986C46.3468 221.9 46.3467 221.859 46.3579 221.856C46.3667 221.853 46.3825 221.874 46.4107 221.916Z"
        fill="#49B5B0"
      />
      <path
        d="M46.4107 221.916C46.4863 222.028 46.6513 222.291 47.0113 222.651C47.8689 223.401 48.6919 224.152 49.5026 224.891C51.2052 226.443 52.8537 227.946 54.6546 229.297C84.563 252.227 118.127 260.867 155.679 253.223C203.864 243.587 244.739 198.392 252.382 154.525C253.711 146.55 254.709 138.907 254.709 130.932C254.377 122.956 246.068 114.316 238.758 114.316C229.12 114.316 219.483 119.965 218.486 131.929C217.822 137.91 217.157 143.892 215.828 149.874C209.513 180.446 179.938 215.34 137.401 216.337C126.767 216.669 117.13 214.676 109.487 206.7C100.182 197.062 97.8557 187.758 103.837 176.458C103.962 176.084 104.134 175.756 104.3 175.44C104.576 174.915 104.834 174.422 104.834 173.8C105.167 172.803 105.499 171.142 104.834 170.81C104.17 170.144 102.508 169.812 101.511 170.144C101.281 170.243 101.047 170.342 100.811 170.442C98.6648 171.349 96.3289 172.336 94.5325 174.133L57.6454 210.023C53.6809 213.987 50.0448 217.951 46.4107 221.916Z"
        fill="#49B5B0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M164.985 71.7803C154.35 72.1127 145.377 81.0852 145.377 91.7193C145.377 103.018 154.35 111.991 164.985 111.658C175.951 111.991 185.255 103.018 185.255 92.0517C185.255 80.7529 176.283 71.7803 164.985 71.7803ZM165.649 85.7376C169.305 85.7376 171.963 88.3962 171.963 92.0517C171.963 95.7071 168.973 98.698 165.317 98.698C161.993 98.698 159.003 95.7071 159.003 92.3839C159.003 88.7285 161.993 85.7376 165.649 85.7376Z"
        fill="#0D2B33"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M186.583 134.256C212.504 112.323 225.132 84.4084 225.464 50.5123V40.2104C225.464 34.8933 222.806 32.2349 217.489 32.2349H204.197C183.259 32.5671 163.986 38.2165 146.705 49.8475C138.397 55.497 131.086 62.1433 124.772 69.7865C123.111 71.7804 121.449 72.445 119.123 72.1128C117.129 71.7804 114.803 71.7804 112.809 71.7804C90.2117 72.7774 72.2666 87.3992 66.9495 109C65.6203 114.317 67.6142 117.64 72.9312 118.637C82.2357 120.299 91.5404 122.292 100.845 124.286C101.842 124.618 103.172 125.283 103.837 125.948C112.931 135.042 121.707 143.818 130.787 152.898L131.419 153.53C132.416 154.527 133.08 155.856 133.413 157.185C134.41 161.838 135.324 166.573 136.237 171.309C137.151 176.045 138.065 180.78 139.062 185.433C140.059 190.084 143.05 192.411 147.37 191.413C158.669 188.755 167.974 183.438 175.284 174.133C183.593 163.5 186.583 151.536 185.586 138.244C185.254 136.582 185.254 135.585 186.583 134.256ZM210.823 45.6515C210.957 45.746 211.118 45.8598 211.507 45.8598C212.504 61.1463 210.177 75.7682 203.531 89.3932C192.897 112.988 175.284 129.271 151.358 138.908C149.863 139.573 148.284 140.237 146.706 140.902C145.127 141.567 143.548 142.231 142.053 142.896C140.724 143.561 139.727 143.228 138.73 142.232C130.758 133.927 122.785 125.955 114.813 117.983L114.803 117.972C114.138 117.308 113.806 115.978 114.138 115.314C119.123 102.021 124.773 89.3932 134.077 78.4267C153.019 56.8262 176.947 45.8598 205.526 45.5275H210.509C210.648 45.5275 210.728 45.5846 210.823 45.6515ZM171.63 144.89C172.626 156.188 163.321 171.475 150.693 175.795C149.363 169.814 148.034 163.5 147.038 156.853C147.038 156.521 147.37 155.524 148.034 155.192C152.017 153.533 155.916 151.791 159.815 150.048C163.725 148.301 167.635 146.554 171.63 144.89ZM99.8488 110.329C93.8671 109.332 87.553 108.003 81.5714 106.674C85.227 95.0425 99.8488 85.073 112.477 86.07C111.646 87.8977 110.815 89.8085 109.984 91.7194C109.154 93.6302 108.323 95.541 107.492 97.3687C105.83 101.357 104.169 105.012 102.175 109C101.843 109.664 100.513 110.329 99.8488 110.329Z"
        fill="#0D2B33"
      />
    </svg>
  );
}

function useDownloadQR() {
  useEffect(() => {
    window.downloadQR = async () => {
      const svgElement = document.getElementById("qr-code");
      if (!svgElement) return;

      const svgString = getFixedSvgString(svgElement);

      try {
        const pngDataUrl = await svgToPng(svgString);
        // Send the PNG data URL to the native app
        window.ReactNativeWebView.postMessage(
          JSON.stringify({ type: "qr", dataUrl: pngDataUrl })
        );
      } catch (error) {
        console.error("Error converting SVG to PNG", error);
      }
    };
  }, []);
}

function svgToPng(svgString: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      console.log("Image loaded with dimensions:", img.width, img.height);

      const scale = 20; // scale factor for enlarging the image
      const padding = 20; // padding (in pixels) to add on all sides

      // New canvas dimensions: image dimensions * scale + padding on each side
      canvas.width = img.width * scale + padding * 2;
      canvas.height = img.height * scale + padding * 2;

      if (ctx) {
        // Fill the entire canvas with white before drawing the image
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // Draw the scaled image offset by the padding
        ctx.drawImage(
          img,
          padding,
          padding,
          img.width * scale,
          img.height * scale
        );
      }

      const pngDataUrl = canvas.toDataURL("image/png");
      console.log("Generated PNG data URL length:", pngDataUrl.length);
      resolve(pngDataUrl);
    };
    img.onerror = (e) => {
      console.error("Image load error", e);
      reject(e);
    };

    const svg64 = window.btoa(unescape(encodeURIComponent(svgString)));
    img.src = "data:image/svg+xml;base64," + svg64;
  });
}

/**
 * Clones an SVG element, fixes its dimensions based on its viewBox if needed,
 * and returns a serialized string of the cloned element.
 * This avoids modifying the actual rendered element.
 */
function getFixedSvgString(svgElement: Element): string {
  const clonedSvg = svgElement.cloneNode(true) as Element;
  const width = clonedSvg.getAttribute("width");
  const height = clonedSvg.getAttribute("height");
  if (
    (width && width.trim().endsWith("%")) ||
    (height && height.trim().endsWith("%"))
  ) {
    const viewBox = clonedSvg.getAttribute("viewBox");
    if (viewBox) {
      const parts = viewBox.split(" ");
      if (parts.length === 4) {
        // Use the viewBox width and height as fixed pixel dimensions
        const [, , vbWidth, vbHeight] = parts;
        clonedSvg.setAttribute("width", vbWidth);
        clonedSvg.setAttribute("height", vbHeight);
        console.log("Fixed SVG dimensions on clone:", vbWidth, vbHeight);
      }
    }
  }
  return new XMLSerializer().serializeToString(clonedSvg);
}
